import axios from 'axios';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getWithRetry = (url, retries = 2, delayMs = 2500) =>
  api.get(url).catch((e) => {
    if (retries <= 0) throw e;
    return new Promise((r) => setTimeout(r, delayMs)).then(() => getWithRetry(url, retries - 1, delayMs * 2));
  });

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});
